const GateIcon = ({ strokeColor = '#808080' }) => (
  <svg 
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
  >
    <defs>
      <style>{`
        .cls-1 {
          fill: #fcfcfc;
        }
        .cls-2 {
          fill: #4d4d4d;
        }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
        }
        .cls-3, .cls-4 {
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-5 {
          fill: #fefefe;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
        }
      `}</style>
    </defs>
    <g id="Circles">
      <circle id="Grey_Bkg" data-name="Grey Bkg" className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle id="Grey" className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle id="White_Inner" data-name="White Inner" className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>
    <g id="Shapes">
      <g id="Gate">
        <path className="cls-5" d="M559.13,508.15c-83.94,0-167.05.01-250.16.01-12.09,0-16.56-4.23-16.6-16.48-.24-66.65-.41-133.3-.5-199.95-.02-12.71,4.4-17.1,17.11-17.1,102.63-.04,205.25-.04,307.88.03,15.48.01,19.28,4,19.28,19.18,0,65.82,0,131.63,0,197.45,0,12.84-3.99,16.84-16.78,16.85-19.8,0-39.6,0-60.24,0M558.43,405.17v-105.91h-28.95v184.9h28.95c0-26.1,0-51.71,0-78.99M479.99,484.65h24.95v-185.6h-29.37c0,61.08-.02,121.78.12,182.49,0,1.04,1.77,2.08,4.31,3.11M316.6,324.8v159.3h27.84v-184.84h-27.84v25.54M398.55,431.96v-132.63h-28.09v184.83h28.09v-52.2M611.05,373.36v-74.2h-28.01v185h28.01v-110.8M451.97,329.82v-30.79h-27.97v185.08h27.97v-154.3Z" />
        <path className="cls-1" d="M158.94,397.63c0-49.94,0-99.05,0-148.15,0-12.12,3.83-15.98,15.82-15.99,27.06-.02,54.13-.02,81.19,0,10.4,0,14.99,4.25,15,14.33.07,99.6.09,199.2.08,298.81,0,10.59-4.55,14.91-15.47,14.93-27.06.05-54.13.05-81.19,0-10.96-.02-15.42-4.62-15.43-15.79-.03-49.1-.01-98.21-.01-148.15M246.02,343.22v-82.91h-61.19v275.44h61.19v-192.53Z" />
      </g>
    </g>
  </svg>
);

export default GateIcon;